import PropTypes from "prop-types";
import { useMemo } from "react";
// material
import { CssBaseline } from "@mui/material";
import {
  ThemeProvider as MUIThemeProvider,
  createTheme,
  StyledEngineProvider,
} from "@mui/material/styles";
// hooks
import useDarkMode from "../hooks/useDarkMode";
//
import palette from "./palette";
import componentsOverride from "./overrides";
import shadows, { customShadows } from "./shadows";

// ----------------------------------------------------------------------

ThemeProvider.propTypes = {
  children: PropTypes.node,
};

export default function ThemeProvider({ children }) {
  const { theme: mode, mounted } = useDarkMode();

  const themeOptions = useMemo(
    () => ({
      palette: palette[mode] || palette.light,
      shadows,
      customShadows,
      typography: {
        fontFamily: '"Noto Sans Armenian", sans-serif',
      },
    }),
    [mode],
  );

  const theme = createTheme(themeOptions);
  theme.components = componentsOverride(theme);

  // Prevent hydration mismatch
  if (!mounted) {
    return <div style={{ visibility: "hidden" }}>{children}</div>;
  }

  return (
    <StyledEngineProvider injectFirst>
      <MUIThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MUIThemeProvider>
    </StyledEngineProvider>
  );
}
